import { Syringe, ShieldCheck, Wrench, Database, Droplets } from "lucide-react";
import { Reveal, SectionHead } from "@/components/Reveal";
import { IMAGES, DAY_ITEMS } from "@/content";

const ICONS = [Syringe, ShieldCheck, Droplets, Wrench, Database];

export default function DayByDay() {
  return (
    <section data-testid="daytoday-section" className="relative py-20 lg:py-28 bg-brand-cloud overflow-hidden">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 grid lg:grid-cols-[1fr_1.1fr] gap-14 lg:gap-20 items-start">
        <div className="lg:sticky lg:top-28">
          <SectionHead
            eyebrow="Diseñado para el día a día"
            title="Pensado para la rutina de tu clínica veterinaria"
            sub="Cada detalle del EH8300 VET existe para que la suma de un hemograma sea lo más simple del consultorio: poca muestra, poca cura y resultados estables."
          />
          <Reveal delay={0.2}>
            <div className="relative mt-10 hidden lg:block">
              <div className="absolute -top-4 -left-4 h-full w-full rounded-3xl border-2 border-brand-orange/40" aria-hidden="true" />
              <img
                src={IMAGES.vetExam}
                alt="Veterinario examinando a un paciente canino en la clínica"
                className="relative rounded-3xl object-cover w-full h-[340px] shadow-xl"
                loading="lazy"
              />
            </div>
          </Reveal>
        </div>

        <div className="space-y-5">
          {DAY_ITEMS.map((item, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <Reveal key={item.title} delay={i * 0.07}>
                <div
                  data-testid={`daytoday-item-${i}`}
                  className="card-hover group flex gap-5 rounded-3xl border border-slate-200 bg-white p-6 sm:p-7"
                >
                  <span className="inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-brand-soft text-brand-orange transition-colors duration-300 group-hover:bg-brand-orange group-hover:text-white">
                    <Icon className="h-5 w-5" />
                  </span>
                  <div>
                    <h3 className="font-display text-lg font-bold text-brand-ink">
                      <span className="font-mono2 text-xs text-brand-orange mr-2">0{i + 1}</span>
                      {item.title}
                    </h3>
                    <p className="mt-2 text-slate-600 leading-relaxed">{item.body}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
